import styled from 'styled-components';
import { rem } from 'polished';
import Heading from '@atoms/Heading/Heading';
import Button from '@atoms/Button/Button';
import Text from '@atoms/Text/Text';

export const DeliveryPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // Needed for scrolling to work in the delivery picker
  height: 100%;
`;

export const StyledDeliveryPickerHeading = styled(Heading)`
  text-align: center;
  padding: ${rem(40)} 0 ${rem(28)} 0;
`;

export const StyledBackButton = styled(Button)`
  position: absolute;
  top: ${rem(20)};
  left: ${rem(20)};
`;

export const StyledDeliveryBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${rem(20)} 0 ${rem(20)};
  gap: ${rem(20)};
`;

export const StyledErrorText = styled(Text)`
  padding: ${rem(0)} ${rem(20)} ${rem(16)} ${rem(20)};
`;
